export enum AuthAction {
  Create,
  Read,
  Update,
}

export enum Module {
  RegulatoryIntake,
  UserManagement,
}

export enum SubModule {
  RegulatoryIntake,
  UserManagement,
}

// Roles must match what the backend returns in `IAuthProfile.roles`.
export enum Role {
  Unknown = 'Unknown',
  Reviewer = 'Reviewer',
  SystemAdmin = 'System Administrator',
}
